'use client'
import { useLocale } from 'next-intl'

export interface UseHeaderRTLReturn {
    isRTL: boolean
    direction: 'rtl' | 'ltr'
}

/** Hook for RTL detection and handling (mobile header only) */
export const useHeaderRTL = (): UseHeaderRTLReturn => {
    const locale = useLocale()
    const isRTL = locale === 'ar'

    return {
        isRTL,
        direction: isRTL ? 'rtl' : 'ltr'
    }
}
